<script setup>
const props = defineProps(['content']);
</script>

<template>
  <div class="editor" v-html="`<p>${props.content.text}</p>`" />
</template>
